//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import convertThDateStringToDateString from '../../utils/convertThDateStringToDateString'
import convertDateStringToThDateString from '../../utils/convertDateStringToThDateString'

import ImageUpload from './ImageUpload'

export default {
  name: "PayinEdit",
  components:{
      VueCtkDateTimePicker,
      ImageUpload,
  },
  data() {
    return {
        formErrors: {
            paid_amount: false,
            paid_datetime: false,
        },
        loading: false,
        datePaymentEdit: '',
        paymentEdit : {},
    };
  },
  props: [ 
    'payment',
    'handleUpdatePayment',  
    'handleCancelEditPayment',
  ],
  created(){

      this.paymentEdit = {
        paidbyid: this.payment.payment_paidbyid,
        paid_amount: this.payment.payment_price,
        paid_date: convertThDateStringToDateString(this.payment.payment_pay_date_display),
        paid_time: this.payment.payment_pay_time ? this.payment.payment_pay_time : '00:00:00',
        channel: this.payment.payment_channel,
        remark: this.payment.payment_remark,
        payment_documentname: this.payment.payment_documentname,
        is_remove_image: false,
      }
      this.datePaymentEdit = `${convertThDateStringToDateString(this.payment.payment_pay_date_display)} ${this.payment.payment_pay_time ? this.payment.payment_pay_time : '00:00:00'}`
  },
  watch:{
      datePaymentEdit(newDatePaymentEdit){
        if (newDatePaymentEdit) {
            const newDatePaymentEditArray = newDatePaymentEdit.split(' ')
            this.paymentEdit.paid_date_display = convertDateStringToThDateString(newDatePaymentEditArray[0])
            this.paymentEdit.paid_date = newDatePaymentEditArray[0]
            this.paymentEdit.paid_time = newDatePaymentEditArray[1]
            this.validate()
        }
      }
  },
  mounted(){
  },
  beforeDestroy() {
  },
  methods: {
    validate(){
        this.formErrors.paid_amount = !this.paymentEdit.paid_amount ? true : false
        this.formErrors.paid_datetime = this.paymentEdit.paid_date == '' || this.paymentEdit.paid_time == '' ? true : false
        return this.formErrors.paid_amount === true || this.formErrors.paid_datetime === true
    },
    handleUpdateInput(e){
        this.validate()
    },
    handleUploadImage(file, isRemoveImage = false){
        this.paymentEdit.image_file = file ? file : null
        this.paymentEdit.is_remove_image = isRemoveImage
    },
    async updatePayment(){
        const hasError = this.validate()
        if(hasError === true){
            return
        }
        this.loading = true
        const resUpdatePayment = await this.handleUpdatePayment(this.paymentEdit)
        if (resUpdatePayment && resUpdatePayment.success){
            this.loading = false
        }
    }
  }
}
